<div class="card modern-card d-flex flex-column">
  <div class="card-header border-0 bg-transparent pt-3 px-4">
    <div class="d-flex justify-content-between align-items-center">
      <div class="header-content">
        <h1 class="modern-header">Expense Table</h1>
      </div>

      <div class="header-actions">
        <button
          type="button"
          class="close-btn"
          (click)="sharedService.changeRoute('home')"
          title="Close"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
    </div>

    <div
      class="action-bar mt-3 d-flex justify-content-between align-items-center bg-dark-subtle rounded-3"
    >
      <div class="left-actions">
        <button
          class="btn modern-btn blue-btn btn-sm"
          (click)="refreshTableDataClick()"
        >
          <i class="fa-solid fa-rotate me-2"></i>Refresh Table
        </button>
      </div>

      <div class="right-actions d-flex gap-2">
        <div class="btn-group" dropdown container="body" placement="bottom right">
          <button
            dropdownToggle
            type="button"
            class="btn modern-btn grey-btn dropdown-toggle btn-sm"
          >
            New Transaction
          </button>
          <ul
            *dropdownMenu
            class="dropdown-menu dropdown-menu-dark modern-dropdown shadow-lg dropdown-menu-end"
          >
            <li>
              <a class="dropdown-item" (click)="createNewExpense()"
                ><i class="fa-solid fa-plus me-2"></i>Create Expense</a
              >
            </li>
            <li>
              <a class="dropdown-item" (click)="createNewVendorCredit()"
                ><i class="fa-solid fa-file-invoice-dollar me-2"></i>Create
                Vendor Credit</a
              >
            </li>
            <li class="dropdown-divider"></li>
            <li>
              <a
                class="dropdown-item"
                (click)="saveCurrentTablePreferencesClick()"
                ><i class="fa-solid fa-floppy-disk me-2"></i>Save Table
                Settings</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="card-body p-0 d-flex flex-column flex-grow-1">
    <ag-grid-angular
      #grid
      id="expense_list"
      class="modern-grid flex-grow-1"
      style="width: 100%; height: 100%"
      
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [gridOptions]="gridOptions"
      [rowData]="accountingService.expense_records"
      [animateRows]="true"
      [rowSelection]="rowSelection"
      [components]="components"
      [enableBrowserTooltips]="true"
      [pagination]="true"
      [paginationPageSize]="sharedService.default_pagination_page_size"
      [preventDefaultOnContextMenu]="true"
      (gridReady)="onGridReady($event)"
      (cellContextMenu)="onCellContextMenu($event)"
      (filterChanged)="storeCurrentSessionFilters()"
      (columnPinned)="storeCurrentSessionColumnConfig()"
      (columnResized)="storeCurrentSessionColumnConfig()"
      (columnMoved)="storeCurrentSessionColumnConfig()"
      (sortChanged)="storeCurrentSessionColumnConfig()"
    ></ag-grid-angular>
  </div>
</div>

<!-- Added for the right click "Copy" function -->
@if ((menuState$ | async)?.showMenu) {
  <div
    class="custom-context-menu"
    [style.top.px]="(menuState$ | async)?.menuTop"
    [style.left.px]="(menuState$ | async)?.menuLeft"
    (click)="copyCellValue()"
    (mouseenter)="onMenuMouseEnter()"
    (mouseleave)="onMenuMouseLeave()"
  >
    <i class="fa-solid fa-copy me-2"></i> Copy
  </div>
}
